module.exports = __webpack_public_path__ + "static/media/Rectangle1.a4451114.png";